'use client'

import SectionSwiper from '@component/layout/section/swiper'
import ListingsCard from './card'
import { useCallback, useMemo } from 'react'
import { join, map, omit, size, slice } from 'lodash-es'
import { statsHouseClick, statsHouseView } from '@plugin/statistics'
import { useSearchParams } from 'next/navigation'
import useFetch from '@hooks/useFetch'

export default function PremiumPropertyContent({
  children,
  width = 940,
  slidesPerView = 3,
}) {

  const searchParams = useSearchParams()
  const [carouselId, query] = useMemo(() => {
    const allParams = {}
    searchParams.forEach((val, key) => {
      allParams[key] = val
    })
    return [
      searchParams.get('carousel'),
      omit(allParams, ['carousel'])
    ]
  }, [searchParams])

  const { data } = useFetch({ url: 'houses/homepage/premium', params: { carouselId } })

  const viewHandle = useMemo(() => statsHouseView(carouselId, 'nzh-carousel'), [carouselId])
  const clickHandle = useMemo(() => statsHouseClick(carouselId, 'nzh-carousel'), [carouselId])

  const changeHandle = useCallback(swiper => {
    const d = swiper.realIndex === 0
      ? slice(data, data.length - swiper.params.slidesPerGroup, data.length)
      : slice(data, swiper.realIndex - swiper.params.slidesPerGroup, swiper.realIndex)

    viewHandle(join(map(d, 'id'), ','))()
  }, [data, viewHandle])

  return size(data) > 0 && (
    <main className='md:px-16 lg:px-40'>
      <div className='max-w-full mx-auto' style={{ width }}>
        {children}
        <SectionSwiper
          data={data}
          autoplay={{
            pauseOnMouseEnter: true
          }}
          slidesPerView={slidesPerView}
          showNext={false}
          mobileNavigation
          dataKey='id'
          slideClassName='py-12'
          swiperClassName='-my-12'
          Card={ListingsCard}
          cardParams={{ useFavorite: false, target: '_blank', query }}
          navClick={changeHandle}
          slideClick={d => clickHandle(d.id)()}
        ></SectionSwiper>
      </div>
    </main>
  )
}